// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sistema/storico',
    requestBody: null,
    response: '{"success":true,"data":{"giorni":"number","database":[{"id":"number","esito":"string","eseguitoIl":"string","durataSec":"number","dimensione":"number","numeroFile":"number","messaggio":"string"}],"documenti":[{...}],"ripristino":[{"id":"number","esito":"string","eseguitoIl":"string","durataSec":"number","dumpNome":"string","tabelleRipristinate":"number","tabelleProduzione":"number","tabelleMancanti":"number","tabelleAllineate":"number","righeRipristinate":"number","schemaPiuRecente":"boolean","messaggio":"string"}],"aggiornamenti":[{"id":"number","host":"string","giorno":"string","numeroPacchetti":"number","kernelAggiornato":"boolean","kernelVersione":"string","riavviatoDopo":"boolean","ultimoIntervento":"string","pacchetti":[{"nome":"string","da":"string","a":"string"}]}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/sistema/stato',
    requestBody: null,
    response: '{"success":true,"data":{"versione":{"build":"string","rilasciatoIl":"string","commit":"string"},"backup":{"database":{...},"documenti":{...}},"restore":{...},"host":{"host":"string","salute":"string","rilevatoIl":"string","distro":"string","kernelInEsecuzione":"string","kernelPiuRecente":"string","kernelDisallineato":"boolean","pacchettiPendenti":"number","riavvioRichiesto":"boolean","aggiornamentiAutomatici":"boolean","riavvioAutomatico":"boolean","orarioRiavvio":"string","prossimaCorsa":"string"}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/integrazioni/stato?societaId=N',
    requestBody: null,
    response: '{"success":true,"data":{"sogliaOre":"number","integrazioni":[{"tipo":"string","nome":"string","modulo":"string","percorso":"string","salute":"string","ultimoAccessoAt":"string","voci":[{"societaId":"number","societaNome":"string","riferimento":"string","salute":"string","ultimoAccessoAt":"string","esitoOk":"boolean","messaggio":"string","origine":"string"}]}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/messaggi/ricevuti',
    requestBody: null,
    response: '[{ id, oggetto, priorita, createdAt, mittente_nome, stato }]'
  },
  {
    method: 'GET',
    endpoint: '/api/assistenza/ticket',
    requestBody: null,
    response: '{ success: true, data: [{ id, tipo, priorita, stato, titolo, modulo, urlPagina, createdByName, createdAt, societa: { id, nome }, _count: { allegati, risposte } }] }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
